/*
 * popup-signup.js
 *
 * Intercepts submission of the popup newsletter form (when rendered with
 * enable_phone: true in snippets/newsletter-form.liquid), validates inputs,
 * and POSTs to the popup-signup backend which creates a Shopify customer
 * with email + SMS marketing consent via Admin API customerCreate.
 */
(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var E164_RE = /^\+[1-9]\d{6,14}$/;

  function buildE164(country, local) {
    var digits = String(local || '').replace(/\D+/g, '').replace(/^0+/, '');
    return (country || '') + digits;
  }

  function decodeEntities(s) {
    var ta = document.createElement('textarea');
    ta.innerHTML = String(s || '');
    return ta.value;
  }

  function showStatus(form, kind, message) {
    var box = form.querySelector('[data-popup-signup-status]');
    if (!box) return;
    box.hidden = false;
    var cls = kind === 'success' ? 'form-status__message--success' : 'form-status__message--error';
    box.textContent = '';
    var span = document.createElement('span');
    span.className = 'form-status__message ' + cls;
    span.setAttribute('tabindex', '0');
    span.setAttribute('data-form-status', '');
    span.textContent = decodeEntities(message);
    box.appendChild(span);
    try { span.focus(); } catch (e) {}
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function hideInner(form) {
    var inner = form.querySelector('[data-popup-signup-inner]');
    if (inner) inner.style.display = 'none';
  }

  function errorMessage(form, code) {
    var ds = form.dataset;
    switch (code) {
      case 'invalid_email': return ds.popupSignupErrEmail;
      case 'invalid_phone': return ds.popupSignupErrPhone;
      case 'already_subscribed':
      case 'phone_taken': return ds.popupSignupErrAlready;
      default: return ds.popupSignupErrServer;
    }
  }

  function onSubmit(e) {
    var form = e.currentTarget;
    e.preventDefault();

    if (form.dataset.popupSignupSubmitting === '1') return;

    var endpoint = form.dataset.popupSignupEndpoint;
    var locale = form.dataset.popupSignupLocale || 'it';

    var email = (form.querySelector('input[name="email"]') || {}).value || '';
    var country = (form.querySelector('select[name="phone_country"]') || {}).value || '';
    var phoneLocal = (form.querySelector('input[name="phone"]') || {}).value || '';

    email = email.trim().toLowerCase();
    var phone = buildE164(country, phoneLocal);

    if (!EMAIL_RE.test(email)) {
      showStatus(form, 'error', errorMessage(form, 'invalid_email'));
      return;
    }
    if (!E164_RE.test(phone)) {
      showStatus(form, 'error', errorMessage(form, 'invalid_phone'));
      return;
    }

    form.dataset.popupSignupSubmitting = '1';
    var btn = form.querySelector('button[type="submit"], [type="submit"]');
    if (btn) btn.setAttribute('disabled', 'disabled');

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, phone: phone, locale: locale }),
      credentials: 'omit',
      mode: 'cors',
    })
      .then(function (r) { return r.json().then(function (j) { return { status: r.status, body: j }; }); })
      .then(function (res) {
        form.dataset.popupSignupSubmitting = '0';
        if (btn) btn.removeAttribute('disabled');

        if (res.status === 200 && res.body && res.body.ok) {
          showStatus(form, 'success', form.dataset.popupSignupSuccessMsg);
          hideInner(form);
          try {
            document.dispatchEvent(new CustomEvent('popup-signup:success', {
              detail: { email: email, customer_id: res.body.customer_id }
            }));
          } catch (e) {}
          return;
        }
        var code = (res.body && res.body.error) || 'server_error';
        showStatus(form, 'error', errorMessage(form, code));
      })
      .catch(function () {
        form.dataset.popupSignupSubmitting = '0';
        if (btn) btn.removeAttribute('disabled');
        showStatus(form, 'error', errorMessage(form, 'server_error'));
      });
  }

  function bind(form) {
    if (form.dataset.popupSignupBound === '1') return;
    form.dataset.popupSignupBound = '1';
    form.addEventListener('submit', onSubmit);
  }

  function bindAll() {
    var forms = document.querySelectorAll('form[data-popup-signup]');
    for (var i = 0; i < forms.length; i++) bind(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  // Re-bind when popup is inserted dynamically (section rerender in theme editor, etc.)
  document.addEventListener('shopify:section:load', bindAll);
  var mo = new MutationObserver(function () { bindAll(); });
  mo.observe(document.body, { childList: true, subtree: true });
})();
